export enum SurveyStatus {
  NotStarted = 0,
  InProgress = 1,
  Completed = 2,
  Exported = 3,
  Error = 999,
}
